function Apply() {
  const openPage = () => {
    window.location.href = "https://ws.formzu.net/fgen/S495633754/";
  };

  return (
    <div className="section area-apply">
      <div className="container">
        <button
          type="button"
          className="apply-button"
          onClick={() => {
            openPage();
          }}
        >


          今すぐ申し込む
        </button>
      </div>
    </div>
  );
}

export default Apply;
